import { apiEndpointBase } from "./endpoint.config";

const base = apiEndpointBase;

export default {
  sendDirectMessage: (userId) =>
    base + "chats/direct/" + userId + "/send-message",
  editDirectMessage: (messageId) =>
    base + "chats/direct/edit-message/" + messageId,
  deleteDirectMessage: (messageId, forEveryone = true, communityId = null) =>
    base +
    "chats/direct/delete-message/" +
    messageId +
    "?forEveryone=" +
    forEveryone +
    (communityId ? "&communityId=" + communityId : ""),
  uploadAttachments: (userId) =>
    base + "chats/direct/" + userId + "/upload-attachment",
  markAllMessageAsRead: (userId) =>
    base + "chats/direct/" + userId + "/mark-all-read",
  chats: base + "chats/direct",
  userChat: (userId, lastId = null) =>
    base + "chats/direct/" + userId + "?lastId=" + lastId,
};
